module.exports = __webpack_public_path__ + "static/img/128.55fff59.png";